import React, { FunctionComponent, useState } from 'react'
import { useIntl } from 'react-intl'

import {
  DEFAULT_SESSION_TYPE_BY_MODE,
  NpSessionType,
  SessionTypeSelectorMode,
} from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import { SelectField } from '../../atoms/formElements/SelectField'

const CORE_CARE_DEFAULT_VALUE = 'DEFAULT'

export type ProviderCalendarSessionTypeSelectorProps = {
  show?: boolean
  onChange: (selected: NpSessionType | undefined) => void
  initialValue?: NpSessionType
  mode?: SessionTypeSelectorMode
}

export const ProviderCalendarSessionTypeSelector: FunctionComponent<ProviderCalendarSessionTypeSelectorProps> = ({
  show,
  onChange,
  initialValue,
  mode = SessionTypeSelectorMode.NP,
}) => {
  const { formatMessage } = useIntl()
  const npOptions = [
    {
      label: formatMessage({
        defaultMessage: 'Intake – 60 mins',
        description: 'NP intake session type option',
      }),
      value: NpSessionType.NP_CLINICAL_INTAKE,
    },
    {
      label: formatMessage({
        defaultMessage: 'Testing – 120 mins',
        description: 'NP testing session type option',
      }),
      value: NpSessionType.NP_TESTING_SESSION,
    },
    {
      label: formatMessage({
        defaultMessage: 'Feedback – 30 mins',
        description: 'NP feedback session type option',
      }),
      value: NpSessionType.NP_POST_SESSION,
    },
  ]
  const coreCareOptions = [
    {
      label: formatMessage({
        defaultMessage: 'Core Care',
        description: 'Core care default session type option',
      }),
      value: CORE_CARE_DEFAULT_VALUE,
    },
    {
      label: formatMessage({
        defaultMessage: 'NP Intake',
        description: 'Core care intake session type option',
      }),
      value: NpSessionType.NP_CLINICAL_INTAKE,
    },
  ]
  const options = mode === SessionTypeSelectorMode.NP ? npOptions : coreCareOptions
  const defaultValue = initialValue ?? DEFAULT_SESSION_TYPE_BY_MODE[mode] ?? CORE_CARE_DEFAULT_VALUE
  const [selectedValue, setSelectedValue] = useState<string>(defaultValue)
  const handleChange = (selected: string) => {
    setSelectedValue(selected)
    onChange(selected === CORE_CARE_DEFAULT_VALUE ? undefined : (selected as NpSessionType))
  }

  if (!show) {
    return null
  }
  return (
    <SelectField
      label={formatMessage({
        defaultMessage: 'Session type',
        description: 'Label for NP session type selector',
      })}
      value={selectedValue}
      onChange={handleChange}
      options={options}
      name='npSessionType'
      baseInputStyle={{ marginBottom: 0 }}
    />
  )
}
